"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const utils_1 = require("./utils");
const bulletPoint = `\u2022`;
const NORMAL = "normal";
const OPEN = "open";
const CONSERTS = "Festivaler";
const NO_STATUS = "NO_STATUS";
class Ticket extends React.Component {
    constructor(props) {
        super(props);
        this.isOpenArrangement = () => {
            const { ticketSaleType } = this.props;
            return ticketSaleType === OPEN;
        };
        this.getTicketDisplayMode = () => {
            const { ticketDisplayMode } = this.props;
            switch (ticketDisplayMode) {
                case -2:
                    return { show: false, value: ticketDisplayMode };
                case -1:
                    return { show: true, value: ticketDisplayMode };
                default:
                    return { show: true, value: ticketDisplayMode };
            }
        };
        const preferredLanguage = props.preferredLanguage ? props.preferredLanguage : 'nb';
        moment.locale(preferredLanguage);
    }
    render() {
        const { date, title, link, features, salesActive, salesEnabled, countLow, category, eventTitle, highlightHeading } = this.props;
        const disabledClass = salesEnabled === false || salesActive === false ? 'is-disabled' : '';
        let highightClass = '';
        if (highlightHeading)
            highightClass = 'has-highlight';
        const adFlags = this.getMappedAdFlags();
        const isOpenArrangement = this.isOpenArrangement();
        const ebilletLink = isOpenArrangement ? '' : link;
        const ticketVisibilityMode = this.getTicketDisplayMode();
        const ticketStatus = this.showTicketStatus(ticketVisibilityMode);
        return (React.createElement("a", { className: `Ticket ${disabledClass} ${highightClass} `, href: ebilletLink ? ebilletLink : null },
            React.createElement("div", { className: "ticket-body" },
                adFlags.length > 0 && (React.createElement("div", { className: "badge-list" }, adFlags.map((flag, index) => (React.createElement("div", { key: index, className: "badge is-highlight" }, flag))))),
                category !== CONSERTS
                    ? React.createElement("div", { className: "ticket-info" },
                        React.createElement("div", { className: "ticket-time" }, this.getTime(date)),
                        React.createElement("div", { className: "ticket-title" },
                            React.createElement("span", null, title)))
                    :
                        React.createElement("div", { className: "ticket-info" },
                            React.createElement("div", { className: "ticket-event-title" },
                                React.createElement("span", null, eventTitle)),
                            React.createElement("div", { className: "ticket-title" },
                                React.createElement("span", null, title))),
                React.createElement("div", { className: "badge-list" }, features.map((feature, index) => (React.createElement("div", { key: index, className: `badge ${feature.highlight ? 'is-highlight' : ''}` }, feature.name)))),
                !isOpenArrangement && React.createElement("div", { className: "ticket-arrow" },
                    React.createElement("img", { src: icons_1.arrowheadRightIcon, alt: "" }))),
            React.createElement("div", { className: "ticket-footer", style: { display: ticketStatus === NO_STATUS ? "none" : '' } },
                countLow &&
                    React.createElement("span", null,
                        React.createElement("img", { src: icons_1.exclamationIcon })),
                this.showTicketStatus(ticketVisibilityMode)),
            highightClass && React.createElement("div", { className: "hightlight-title" }, highlightHeading)));
    }
    getWebStartDateFormat() {
        const { ticketSaleWebStartDate } = this.props;
        const text = "Billettsalget åpner ";
        var thisYear = moment().format('YYYY');
        var yearOfTicketSale = moment(ticketSaleWebStartDate).format('YYYY');
        if (thisYear !== yearOfTicketSale) {
            return text + moment.utc(ticketSaleWebStartDate).format('llll');
        }
        return text + this.getDate() + ' kl ' + moment.utc(ticketSaleWebStartDate).format('HH:mm');
    }
    getDate() {
        const { ticketSaleWebStartDate } = this.props;
        return moment(ticketSaleWebStartDate).format('D') + '.'
            + moment(ticketSaleWebStartDate).format('MMM');
    }
    getTime(date) {
        const day = utils_1.capitalizeFirstLetter(moment(date).format("dddd"));
        return this.props.showFullDate
            ? `${day} ${moment(date).format("DD. MMMM")} ${bulletPoint} ${moment.utc(date).format("HH:mm")}`
            : moment.utc(date).format('HH:mm');
    }
    getMappedAdFlags() {
        const { adFlags, adFlagsView } = this.props;
        const flags = [];
        if (!adFlags || !adFlagsView) {
            return [];
        }
        adFlags.forEach(flag => {
            const flagView = adFlagsView.find(flagView => (flagView.flag === flag));
            if (flagView) {
                flags.push(flagView.view);
            }
        });
        return flags;
    }
    showTicketStatus(ticketVisibilityMode) {
        const { count, ticketSaleType, salesEnabled, salesActive, link, ticketSaleWebStartDate, ticketSaleWebEndDate } = this.props;
        const beginWeb = moment(ticketSaleWebStartDate);
        if (salesActive === false && ticketSaleWebEndDate) {
            return "Salg er stoppet";
        }
        else if (salesActive === false && ticketSaleWebStartDate && beginWeb.isBefore(moment())) {
            return "Salg er over";
        }
        else if (salesActive === false && ticketSaleWebStartDate && beginWeb.isAfter(moment())) {
            return this.getWebStartDateFormat();
        }
        else if (count <= 0 && link && ticketSaleType === NORMAL) {
            return "Utsolgt";
        }
        else if (ticketSaleType === OPEN) {
            return "Gratis arrangement";
        }
        else if (salesEnabled === false) {
            return "Salg ikke åpnet";
        }
        else if (ticketVisibilityMode && ticketVisibilityMode.show && count > 0 && count < ticketVisibilityMode.value) {
            return "Få ledige";
        }
        else if (ticketVisibilityMode && ticketVisibilityMode.show && link) {
            return `${count} ledige`;
        }
        return NO_STATUS;
    }
}
exports.Ticket = Ticket;
exports.default = Ticket;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-ticket/Ticket.tsx